/**
 * Classe que gerencia a funcionalidade de mostrar comentarios ao selecionar o campo de rating
 */

Greenmile.Rating = Greenmile.Rating || {};

Greenmile.Rating.Comment = function(target) {

  const getComments = () => {
    const ajax = new Monet.Ajax(),
          id       = target.id,
          akey = target.getAttribute("akey");

    ajax.url = `StopView/restrictions?criteria={"filters":
      ["stopSignature.comment", "stop.actualArrival", "stop.location.key", "stop.location.description"],
      "firstResult":0,"maxResults":51}`;

    ajax.method = 'POST';

    ajax.data = `{"criteriaChain":[{"and":[
      {"matchMode":"EXACT","attr":"stop.key","eq":"${akey}"},
      {"attr":"route.id","eq":${id}}]}]}`;
    ajax.beforeSend = () => {
      modal.iconLoading();
    };
    ajax.success = (data) => {
      generateModalContent(data[0]);
    };

    ajax.error = () => {
      this.modalForm.closeModalWindow();
      $.toast({
        message: Monet.I18n.getResourcesByKey("Stop.Rating.Comment.FilterError"),
        displayTime: 1300,
        inTime: 100,
        outTime: 400,
        maxWidth: 700,
        vPosition: "center",
        hPosition: "center",
        className: "toastError signaturePopupRequestFilters",
      });
    };

    ajax.send();
  }

  const generateModalContent = (data) => {
    const popupContainer = document.querySelector(".popupFormContainer")
    popupContainer.classList.add("comment-popup")

    const popupTitleContainer = document.createElement("div");
    popupTitleContainer.className = 'bold_title comment_title';
    popupTitleContainer.appendChild(document.createTextNode(`${Monet.I18n.getResourcesByKey('Stop.Rating.Comment.titleComment')} `));
    popupContainer.appendChild(popupTitleContainer);

    const commentContainer = document.createElement("div"),
    commentTitle = document.createElement("span");

    popupContainer.append(commentContainer);
    
    commentTitle.className = 'bold_title';
    
    commentContainer.className = 'comment_container';
    if (data.stopSignature && data.stopSignature.comment){
      const getDate = (date) => {
        return Monet.Format.DateTime.getFormattedLocaleToday(date)
      }
      commentTitle.appendChild(document.createTextNode(`${Monet.I18n.getResourcesByKey('Stop.Rating.Comment.comment')} `));
      commentContainer.classList.add("rating-comment-filled")
      
      let stopName = document.createElement("span")
      stopName.classList.add("rating-comment-filled-title")
      stopName.appendChild(document.createTextNode(` ${data.stop.location.key} - ${data.stop.location.description}`))
      commentContainer.appendChild(stopName);
      
      let stopComment = document.createElement("span")
      stopComment.classList.add("rating-comment-filled-comment")
      stopComment.appendChild(document.createTextNode(data.stopSignature.comment))
      commentContainer.appendChild(stopComment);
      
      let stopDate = document.createElement("span")
      let date = new Date(data.stop.actualArrival)
      stopDate.classList.add("rating-comment-filled-date")
      stopDate.appendChild(document.createTextNode(getDate(date)))
      commentContainer.appendChild(stopDate)
    }
    else {
      let createStopString = () => {
        let template = `${data.stop.location.key} - ${data.stop.location.description}`
        let string = Monet.I18n.getResourcesByKey('Stop.Rating.Comment.signalStop', template)
        return string
      }

      let ratingContainer = document.createElement("div")
      let ratingIcon = document.createElement("img")
      ratingIcon.setAttribute("src", 'data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIzMS40ODMiIGhlaWdodD0iMzEuNDgzIiB2aWV3Qm94PSIwIDAgMzEuNDgzIDMxLjQ4MyI+PHBhdGggZD0iTTEzLjAxOSwzMy40ODNhMS41NzQsMS41NzQsMCwwLDEtMS41NzQtMS41NzRWMjcuMTg2aC02LjNBMy4xNDgsMy4xNDgsMCwwLDEsMiwyNC4wMzhWNS4xNDhBMy4xNDcsMy4xNDcsMCwwLDEsNS4xNDgsMkgzMC4zMzVhMy4xNDgsMy4xNDgsMCwwLDEsMy4xNDgsMy4xNDh2MTguODlhMy4xNDgsMy4xNDgsMCwwLDEtMy4xNDgsMy4xNDhoLTkuNmwtNS44MjQsNS44NGExLjYsMS42LDAsMCwxLTEuMS40NTdoLS43ODdtMS41NzQtOS40NDV2NC44NDhsNC44NDgtNC44NDhIMzAuMzM1VjUuMTQ4SDUuMTQ4djE4Ljg5aDkuNDQ1TTguMyw5Ljg3MWgxOC44OXYzLjE0OEg4LjNWOS44NzFtMCw2LjNIMjIuNDY0djMuMTQ4SDguM1oiIHRyYW5zZm9ybT0idHJhbnNsYXRlKC0yIC0yKSIgZmlsbD0iIzk1OTg5YSIvPjwvc3ZnPg==')
      ratingIcon.setAttribute("height", '31.5px')
      ratingIcon.setAttribute("width", '31.5px')
      
      ratingContainer.classList.add("comment-empty-image")
      popupContainer.classList.add("comment-popup-empty")
      commentContainer.classList.add("rating-comment-empty");

      ratingContainer.appendChild(ratingIcon);
      commentContainer.appendChild(ratingContainer);

      let noCommentsSpan = document.createElement('span')
      noCommentsSpan.classList.add("rating-comment-empty-text")
      noCommentsSpan.appendChild(document.createTextNode(Monet.I18n.getResourcesByKey('Stop.Rating.Comment.noComments')))
      commentContainer.appendChild(noCommentsSpan);

      let div = document.createElement('div')      
      div.appendChild(document.createTextNode(createStopString()));
      div.classList.add('rating-comment-empty-text')
      commentContainer.appendChild(div)
    }
  }

  const showModal = () => {
    var selector = "#RouteSummary";
    var scopeBlock = `${selector} #allContent`;

    var options = {
      width: 600,
      height: 400
    };

    var callbacks = {
      onAfterShowModalForm: getComments
    };

    this.modalForm = new Monet.Form.Modal(selector, options, callbacks, scopeBlock);
    this.modalForm.showModalForm();

  };

  showModal();

}